import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProcessStepper from "../../../../components/stepperprocess/ProcessStepper";
import { CardPos, Personalcard, Verify } from "iconsax-react";
import {
  panVerify,
  aadharVerify,
  bankVerify,
} from "../../../../redux/slices/memberVerifySlice";
import { changePartnerStatus } from "../../../../redux/slices/changePartnerStatusSlice";

import { toast } from "react-toastify";
import { CloudDownload } from "lucide-react";
import downloadImageFromUrl from "../../../../utils/fileDownloadService"; // ✅ default import

const KycProcess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const company = location.state?.company;
  const userType = location.state?.userType;
  const [token, setToken] = useState("");
  const memberID = company?.member_id;
  const { panStatus, aadharStatus, bankStatus, loading, error } = useSelector(
    (state) => state.memberVerify
  );

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken");
    console.log(company);
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const handlePanVerify = () => {
    dispatch(
      panVerify({ member_id: memberID, pan_no: company.member_pan, token })
    );
  };

  const handleAadharVerify = () => {
    dispatch(
      aadharVerify({
        member_id: memberID,
        aadhar_no: company.member_aadhar,
        token,
      })
    );
  };

  const handleBankVerify = () => {
    dispatch(
      bankVerify({
        member_id: memberID,
        account_no: company.member_account,
        ifsc: company.member_ifsc,
        token,
      })
    );
  };

  const handleApprove = () => {
    dispatch(changePartnerStatus({ member_id: memberID, is_active: 1, token }));
    toast.success("updated successfully");
    navigate("/dashboard");
  };

  const handleReject = () => {
    dispatch(changePartnerStatus({ member_id: memberID, is_active: 0, token }));
    toast.success("Reject successfully");
    navigate("/dashboard");
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (!company) {
    return (
      <div className="container py-4">
        <p>
          No KYC data found.{" "}
          <button className="btn btn-link" onClick={handleBack}>
            Go back
          </button>
        </p>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh" }}>
      <ProcessStepper currentStep={2} userType={userType} />
      <div className="flex-grow-1">
        <div className="p-4 shadow rounded bg-white">
          <h4>KYC Documents</h4>

          {/* PAN */}
          <div className="px-4">
            <div className="card px-2 py-1 headingBar">
              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    <Personalcard size="32" color="#FF8A65" variant="Bold" />
                  </span>
                  <span style={{ color: "#ffffff" }}> Pancard Card Number</span>
                </div>
                <div className="btn_suffer">
                  
                </div>
              </div>
            </div>
            <div className="p-2">
              <div className="d-flex">
            <div className="col-6">
              <p style={{ fontWeight: "bold" }}>Pan No : {company.member_pan}</p>
            </div>
            <div className="col-6 d-flex justify-content-end">
              {panStatus ? (
                    <div className="box_status">
                      <p className="text-success">
                        {" "}
                        <span>
                          {" "}
                          <Verify size="32" color="#2ecc71" variant="Bold" />
                        </span>{" "}
                        Pan Verified
                      </p>{" "}
                    </div>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={handlePanVerify}
                    >
                      Verify
                    </button>
                  )}
            </div>
          </div>

          <div className="d-flex justify-content-around gap-4 mb-4">
            <div className="card p-3">
              <img
                src={company.member_pan_front_url}
                alt="PAN Front"
                style={{
                  width: 300,
                  height: 200,
                  // borderRadius: 10,
                  boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                }}
              />
              <div className="d-flex justify-content-around mt-4">
                <p>PAN Card Front</p>
                <CloudDownload
                  color={"#52357B"}
                  onClick={() => {
                    downloadImageFromUrl(
                      company.member_pan_front_url,
                      "pan_front.jpg"
                    );
                  }}
                />
              </div>
            </div>
            <div className="card p-3">
              <img
                src={company.member_pan_back_url}
                alt="PAN Back"
                style={{
                  width: 300,
                  height: 200,
                  // borderRadius: 10,
                  boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                }}
              />
              <div className="d-flex justify-content-around mt-4">
                <p>PAN Card Back</p>
                <CloudDownload
                  color={"#52357B"}
                  onClick={() => {
                    downloadImageFromUrl(
                      company.member_pan_back_url,
                      "pan_back.jpg"
                    );
                  }}
                />
              </div>
            </div>
          </div>
            </div>
          </div>
          
          

          {/* Aadhar */}
          <div className="px-4 mb-3">
            <div className="card px-2 py-1 headingBar">
              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    <Personalcard size="32" color="#FF8A65" variant="Bold" />
                  </span>
                  <span style={{ color: "#ffffff" }}> Aadhar Card Number</span>
                </div>
                <div className="btn_suffer">{/*  */}</div>
              </div>
            </div>
            <div className="p-2">
              <div className="d-flex ">
                <div className="col-6">
                  <p style={{ fontWeight: "bold" }}>
                    Aadhar Card No:{company.member_aadhar}
                  </p>
                </div>
                <div className="col-6 d-flex justify-content-end">
                  {aadharStatus ? (
                    <div className="box_status">
                      <p className="text-success">
                        {" "}
                        <span>
                          {" "}
                          <Verify size="32" color="#2ecc71" variant="Bold" />
                        </span>{" "}
                        Aadhar Verified
                      </p>{" "}
                    </div>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={handleAadharVerify}
                    >
                      Verify
                    </button>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-around  mb-4">
                <div className="card p-3">
                  <img
                    src={company.member_aadhar_front_url}
                    alt="Aadhar Front"
                    style={{
                      width: 300,
                      height: 200,
                      // borderRadius: 10,
                      boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                    }}
                  />
                  <div className="d-flex justify-content-around mt-4">
                    <p>Aadhar Card Front</p>
                    <CloudDownload
                      color={"#52357B"}
                      onClick={() => {
                        downloadImageFromUrl(
                          company.member_aadhar_front_url,
                          "aadhar_front.jpg"
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="card p-3">
                  <img
                    src={company.member_aadhar_back_url}
                    alt="Aadhar Back"
                    style={{
                      width: 300,
                      height: 200,
                      // borderRadius: 10,
                      boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                    }}
                  />
                  <div className="d-flex justify-content-around mt-4">
                    <p>Aadhar Card Back</p>
                    <CloudDownload
                      color={"#52357B"}
                      onClick={() => {
                        downloadImageFromUrl(
                          company.member_aadhar_back_url,
                          "aadhar_back.jpg"
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Cheque */}
          <div className="px-5 mb-5">
            <div className="card px-2 py-1 headingBar">
              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    <Personalcard size="32" color="#FF8A65" variant="Bold" />
                  </span>
                  <span style={{ color: "#ffffff" }}>Cheque Image</span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <div className="px-2">
                <div className="card p-3">
                  <img
                    src={company.member_cheque_url}
                    alt="Cheque Book"
                    style={{
                      width: 300,
                      height: 200,
                      // borderRadius: 10,
                      boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                    }}
                  />
                  <div className="d-flex justify-content-around mt-4">
                    <p>Cheque Book</p>
                    <CloudDownload
                      color={"#52357B"}
                      onClick={() => {
                        downloadImageFromUrl(
                          company.member_cheque_url,
                          "cheque_book.jpg"
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bank */}
          <div className="px-5 mb-5">
            <div className="card px-2 py-1 headingBar">
              <div className="d-flex justify-content-between">
                <div>
                  <span>
                    <Personalcard size="32" color="#FF8A65" variant="Bold" />
                  </span>
                  <span style={{ color: "#ffffff" }}>
                    Account for fund settlement
                  </span>
                </div>
                <div className="btn_suffer"></div>
              </div>
            </div>
            <div className="px-2 d-flex mt-2">
              <div className="col-6">
                <p style={{ fontWeight: "bold" }}>
                  {" "}
                  Account Number: {company.member_account}
                </p>
                <p style={{ fontWeight: "bold" }}>
                  {" "}
                  IFSC CODE: {company.member_ifsc}
                </p>
              </div>
              <div className="col-6 ">
                <div className="d-flex justify-content-end">
                  {bankStatus ? (
                    <div className="box_status">
                      <p className="text-success">
                        {" "}
                        <span>
                          {" "}
                          <Verify size="32" color="#2ecc71" variant="Bold" />
                        </span>{" "}
                        Account Number Verified
                      </p>{" "}
                    </div>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={handleBankVerify}
                    >
                      Verify
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Error + Actions */}
          {loading && <p className="text-info">Verifying...</p>}
          {error && <p className="text-danger">Error: {error}</p>}

          <div className="d-flex gap-3 mt-4 justify-content-center">
            <button
              className="btn btn-outline-secondary px-4"
              onClick={handleBack}
            >
              Back
            </button>
            <button
              className="btn btn-outline-danger px-4"
              onClick={handleReject}
            >
              Reject
            </button>
            <button className="btn btn-success px-4" onClick={handleApprove}>
              Approve
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycProcess;
